import { createApiActionType } from 'app/store/utils';

const apiType = createApiActionType('exchangeSource');

export const EXCHANGE_SOURCE = apiType('ExchangeSource');
